import { NotificationInstance } from "antd/es/notification/interface";
import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const NotificationContext = createContext<NotificationInstance>(undefined!);
